import React, { useState } from "react";
import { icons } from "../../assets/icons";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

export const ButtonPlay = () => {
	const [imgPause, setImgPause] = useState(icons.soundOn)
	ObserverEmitter.on(EVENTS.audiosEvents.pauseListen, (pause) => {
		if (pause) {
			setImgPause(icons.soundOff)
		} else {
			setImgPause(icons.soundOn)
		}
	});

	return (
		<div className="fixed z-40 top-5 left-5">
			<div onClick={() => {
				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.navigationHomePause)
				ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive)
			}} className="w-12 h-12 p-3 rounded-full bg-[#00000099] cursor-pointer">
				<img className="h-full w-full object-contain" src={imgPause} alt="play" />
			</div>
		</div>
	);
};
